import type { IntlShape } from 'react-intl'
import getLPCRegionLOS from './getLPCRegionLOS'

export default function getOfferDurationText(
  intl: IntlShape,
  offer: App.Offer | App.OfferSummary,
  pkg: App.Package,
): string {
  if (offer.type === 'rental' && offer.lowestPricePackage) {
    return intl.formatMessage(
      {
        id: 'uLvkNC7zKBL7p1MmWGtU',
        defaultMessage: '{durationLabel} from',
      },
      { durationLabel: offer.lowestPricePackage.durationLabel.toLocaleLowerCase() },
    )
  }
  if (pkg.duration) {
    return intl.formatMessage(
      {
        id: 'bpRr7kqMdQCHkQ_UR10Z',
        defaultMessage: '{count, plural, one {# night} other {# nights}} from',
      },
      { count: pkg.duration },
    )
  }
  if (offer.tileDurationLabel) {
    return intl.formatMessage(
      {
        id: 'qfUz447wt6urAVvxwyJU',
        defaultMessage: '{durationLabel} from',
      },
      { durationLabel: offer.tileDurationLabel.toLocaleLowerCase() },
    )
  }
  const LPCRegionLOS = getLPCRegionLOS(offer)
  if (LPCRegionLOS) {
    return intl.formatMessage(
      {
        id: '0xkXKLduSGUiZzmYMVkA',
        defaultMessage: '{count, plural, one {# night} other {# nights}} from',
      },
      { count: LPCRegionLOS },
    )
  }
  return intl.formatMessage({
    id: 'sqYce3N9moI3ZGynV3ab',
    defaultMessage: 'From',
  })
}
